import React from "react";


const Sitemap: React.FC = () => {
      const useScrollToTop = () => {
        React.useEffect(() => {
          window.scrollTo(0, 0);
        }, []);
      }
      useScrollToTop();
    return (
        <div className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-4">Sitemap</h1>
        <p className="text-gray-700 mb-4">
            This is the sitemap of our website. You can find all the pages listed below.
        </p>
        {/* Add your sitemap content here */}
        </div>
    );
    };
export default Sitemap;